import { GeneratorFormGroupContent } from '@/api/interfaces/content/form/steps/plantPerformance/generatorContent';

export const generatorContent: GeneratorFormGroupContent = {
    generatorHeadline: {
        text: 'Generatoren',
    },
    generatorManufacturerAndModuleType: {
        label: 'Hersteller und Typ',
        manufacturerSelect: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        manufacturerText: {
            placeholder: 'Eco Power',
        },
        moduleTypeSelect: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        moduleTypeText: {
            placeholder: 'Power Unit XRGI 6',
        },
    },
    generatorZerezIdAndNorm: {
        label: 'ZEREZ-ID und Norm',
        zerezId: {
            placeholder: 'Bitte wählen',
            search: {
                placeholder: 'Filter',
                noResults: 'Keine Ergebnisse',
            },
        },
        normText: {
            placeholder: 'VDE AR N 4105 VDE AR-N 4110',
            info:
                'Die Prüfung wird auf Basis des angegeben Zertifikats durchgeführt. Es obliegt dem Anlagenbetreiber die Gültigkeit des Zertifikats zum Zeitpunkt der Inbetriebnahme sicherzustellen, oder ein Folgezertifikat anzubringen. In jedem Fall muss zum Zeitpunkt der Inbetriebnahme ein gültiges Zertifikat vorliegen. Weitere Informationen zu diesem Zertifikat finden Sie unter <a rel="noopener noreferrer" href="https://www.zerez.net/units-and-certificates"> ZEREZ</a>',
        },
    },
    generatorManualInputManufacturerTypeZerezId: {
        label: 'Einheit ist nicht in der Auswahl enthalten',
    },
    unitCertificateInvalidForInstalledPower: {
        text:
            'Die ausgewählte Erzeugungseinheit besitzt kein gültiges Einheitenzertifikat für ihre angegebene installierte Leistung P<sub>inst</sub>.',
    },
    generatorQuantityAndGeneratorType: {
        label: 'Anzahl und Generatorentyp',
        generatorType: {
            placeholder: 'Bitte wählen',
            info:
                'Eine Erzeugungseinheit Typ 1 beinhaltet ausschließlich einen Synchrongenerator, der einen direkt oder nur über einen Maschinentransformator mit dem Netz gekoppelt ist.\nEine Erzeugungseinheit Typ 2 ist jede Einheit, welche nicht die Kriterien einer Typ 1 Einheit erfüllt.',
            options: {
                type1: {
                    label: 'Typ 1',
                },
                type2: {
                    label: 'Typ 2',
                },
            },
        },
    },
    generatorActivePowerAndApparentPower: {
        label:
            'Bemessungswirkleistung P<sub>rE</sub> und Bemessungsscheinleistung S<sub>rE</sub>',
        activePower: {
            placeholder: '10',
            unit: 'kW',
        },
        apparentPower: {
            placeholder: '10',
            unit: 'kVA',
        },
    },
    generatorTotalActivePower: {
        label: 'Summe Bemessungswirkleistung P<sub>rE</sub>',
        unit: '{{ value }} kW',
    },
    generatorTotalApparentPower: {
        label: 'Summe Bemessungsscheinleistung S<sub>rE</sub>',
        unit: '{{ value }} kVA',
    },
    generatorTotalActivePowerIsGreaterThanTotalApparentPowerWarning: {
        text:
            'Die Summe der Wirkleistung kann nie größer sein als die Summe der Scheinleistung.',
    },
    generatorAddRemoveModule: {
        addLabel: 'Generator hinzuf&uuml;gen',
        removeLabel: 'Generator entfernen',
    },
    generatorOverallActivePower: {
        label: 'Gesamtergebnis aus Summe Wirkleistung',
        unit: '{{ value }} kW',
    },
    generatorOverallApparentPower: {
        label: 'Gesamtergebnis aus Summe Scheinleistung',
        unit: '{{ value }} kVA',
    },
};
